export default
/* glsl */
"\nvec3 transformed = vec3( position );\n";